<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mb-5">Klasifikatoriai</h3>

    <v-row class="mb-3">
      <v-col cols="12" md="12">
        <el-autocomplete
          :class="grupeClass"
          :items="filteredGrupes"
          itemvalue="klg_id"
          itemtext="klg_pavadinimas"
          label="Klasifikatorių grupė"
          v-model="grupe"
          @change="grupeChange()"
        />
      </v-col>
    </v-row>

    <admin-klasifikatoriai-detail v-if="isGrupe" :grupe="grupe" :key="grupe" />
  </v-container>
</template>

<script>
import AdminKlasifikatoriaiDetail from './AdminKlasifikatoriaiDetail'
export default {
  name: 'AdminKlasifikatoriai',
  components: { AdminKlasifikatoriaiDetail },
  data() {
    return {
      grupes: [],
      grupe: null,
    }
  },
  computed: {
    isGrupe() {
      return this.grupe ? true : false
    },
    filteredGrupes() {
      return this.grupes.map(grupe => {
        return grupe
      })
    },
    grupeClass() {
      return this.grupe ? '' : 'disabled-select'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true

      this.$axios
        .get(`admin/klasifikatorius`)
        .then(res => {
          this.grupes = res.data.grupes
          this.grupes.unshift({
            klg_id: null,
            klg_pavadinimas: 'Pasirinkite klasifikatoriaus grupę',
            disabled: true,
            selected: true,
          })
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    grupeChange() {
      this.$root.$emit(`checkDataChanged${this.$route.name}`)
    },
  },
}
</script>
